"use client";

import { Tabs, TabsList, TabsTrigger, TabsContent } from "zudoku/ui/Tabs.js";
import { SyntaxHighlight } from "zudoku/ui/SyntaxHighlight.js";

interface CodeTab {
  label: string;
  language: string;
  code: string;
}

interface CodeTabsProps {
  tabs: CodeTab[];
}

export function CodeTabs({ tabs }: CodeTabsProps) {
  return (
    <Tabs defaultValue={tabs[0]?.label} className="my-4">
      <TabsList className="w-full justify-start rounded-b-none border-b bg-transparent p-0">
        {tabs.map((tab) => (
          <TabsTrigger
            key={tab.label}
            value={tab.label}
            className="rounded-none border-b-2 border-transparent px-4 py-2 text-sm font-medium data-[state=active]:border-primary data-[state=active]:bg-transparent"
          >
            {tab.label}
          </TabsTrigger>
        ))}
      </TabsList>
      {tabs.map((tab) => (
        <TabsContent key={tab.label} value={tab.label} className="mt-0">
          <SyntaxHighlight
            language={tab.language}
            code={tab.code}
            showCopy="hover"
            className="!mt-0 !rounded-t-none"
          />
        </TabsContent>
      ))}
    </Tabs>
  );
}
